import styled from "styled-components";

export const PopupContainer = styled.div`
  height: 100%;
  min-width: 350px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  padding-top: 15px;
  height: 100%;
  width: 100%;
  column-gap: 30px;
`;
